export const Realtime = {
  connectionError: "Error de conexión",
  connectionError1: "Lo sentimos, ha ocurrido un error interno de conexión.",
  connectionError2: "Por favor intente más tarde o contacte con soporte.",
};
